import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appIsOpen]',
  standalone: true
})
export class IsOpen implements OnChanges {
  @Input() appIsOpen: boolean | number = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // Add base classes
    this.renderer.addClass(this.el.nativeElement, 'inline-flex');
    this.renderer.addClass(this.el.nativeElement, 'items-center');
    this.renderer.addClass(this.el.nativeElement, 'px-3');
    this.renderer.addClass(this.el.nativeElement, 'py-1');
    this.renderer.addClass(this.el.nativeElement, 'rounded-full');
    this.renderer.addClass(this.el.nativeElement, 'text-sm');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appIsOpen']) {
      this.updateView();
    }
  }

  private updateView(): void {
    // Convert input to boolean (handles 1/0 and true/false)
    const isOpen = Boolean(this.appIsOpen);
    const element = this.el.nativeElement;

    // Reset dynamic classes
    this.renderer.removeClass(element, 'bg-green-100');
    this.renderer.removeClass(element, 'text-green-900');
    this.renderer.removeClass(element, 'bg-red-100');
    this.renderer.removeClass(element, 'text-red-900');
    this.renderer.addClass(element, 'font-bold');

    // Clear content
    element.innerHTML = '';

    // Create dot
    const dot = this.renderer.createElement('span');
    this.renderer.addClass(dot, 'w-2');
    this.renderer.addClass(dot, 'h-2');
    this.renderer.addClass(dot, 'rounded-full');
    this.renderer.addClass(dot, 'mr-2');

    // Create text
    const textSpan = this.renderer.createElement('span');

    if (isOpen) {
      this.renderer.addClass(element, 'bg-green-100');
      this.renderer.addClass(element, 'text-green-900');
      this.renderer.addClass(dot, 'bg-green-500');
      this.renderer.setProperty(textSpan, 'textContent', 'Abierto');
    } else {
      this.renderer.addClass(element, 'bg-red-100');
      this.renderer.addClass(element, 'text-red-900');
      this.renderer.addClass(dot, 'bg-red-500');
      this.renderer.setProperty(textSpan, 'textContent', 'Cerrado');
    }

    this.renderer.appendChild(element, dot);
    this.renderer.appendChild(element, textSpan);
  }
}
